import api from '@/api'
import notifier from '@/notifier'
import { merge } from 'lodash'

export default {
  namespaced: true,
  state: {
    total: 0,
    accounts: [],
    fetching: false,
    lastFetchOptions: null
  },
  actions: {
    async fetchAccounts ({ state, commit, getters }, { options }) {
      commit('fetching')

      try {
        const { total, items } = await api.mercadoLivre.getAccounts(options)

        commit('setFetchData', {
          items, total, options
        })
      } catch (error) {
        notifier.error('Falha ao buscar as contas.', 'Erro')
      }
    },
    async addAccount ({ state, commit, getters }, item) {
      commit('fetching')

      let items = state.accounts
      items.push(item)

      const total = items.length

      commit('setFetchData', {
        items, total
      })
    },
    async setAccount ({ commit }, account) {
      commit('setItem', account)
    },
    async setAccounts ({ state, commit, getters }, items) {
      commit('fetching')

      this.accounts = items

      const total = items.length

      commit('setFetchData', {
        items, total
      })
    }
  },
  getters: {
    getAccount: state => identifier => state.accounts.find(account => account.identifier === identifier)
  },
  mutations: {
    setFetchData (state, { items, total, options }) {
      state.total = total
      state.accounts = items
      state.lastFetchOptions = {...options}
      state.fetching = false
    },
    fetching (state) {
      state.fetching = true
    },
    setItem (state, newItem) {
      const item = state.accounts.find(item => item.identifier === newItem.identifier)
      if (item) {
        merge(item, newItem)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mercadoLivreAccounts.js